export interface iButtonDetails {
  url: string;
}

export const ButtonDetails: iButtonDetails = {
  url: 'http://www.api.org',
};
